import { buildLabelGetter, GetLabelFn } from 'utils/translation';

interface RecruitmentConfig {
  code: string;
  getLabel: GetLabelFn;
  color: string;

  canChangeOwner: boolean;
  canBeFinished: boolean;
  canBeDenied: boolean;
  canComment: boolean;
  isActiveStatus: boolean;
}

export const recruitmentStatusConfig = {
  done: {
    code: '0',
    getLabel: buildLabelGetter('Finished'),
    color: '#00D39D',

    canChangeOwner: false,
    canBeFinished: false,
    canBeDenied: false,
    canComment: false,
    isActiveStatus: false,
  },

  unassigned: {
    code: '1',
    getLabel: buildLabelGetter('Unassigned'),
    color: '#FC8A05',

    canChangeOwner: true,
    canBeFinished: true,
    canBeDenied: true,
    canComment: true,
    isActiveStatus: false,
  },

  notStarted: {
    code: '2',
    getLabel: buildLabelGetter('Not Started'),
    color: '#C4C4C4',

    canChangeOwner: true,
    canBeFinished: true,
    canBeDenied: true,
    canComment: true,
    isActiveStatus: true,
  },

  active: {
    code: '3',
    getLabel: buildLabelGetter('Active'),
    color: '#1560CE',

    canChangeOwner: true,
    canBeFinished: true,
    canBeDenied: false,
    canComment: true,
    isActiveStatus: true,
  },

  denied: {
    code: '9',
    getLabel: buildLabelGetter('Denied'),
    color: '#F3003A',

    canChangeOwner: false,
    canBeFinished: false,
    canBeDenied: false,
    canComment: false,
    isActiveStatus: false,
  },
};

export const recruitmentStatusByCode = Object.fromEntries(
  Object.values(recruitmentStatusConfig).map((config) => [config.code, config]),
) as Record<string, RecruitmentConfig>;
